/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/**
 * Fix: the thumbnail strip's Swiper instance (.product-media-nav)
 * also binds navigation to the same .swiper-button-next /
 * .swiper-button-prev elements used by the main product image
 * Swiper (.product-media), and re-asserts its own (wrong) disabled
 * state on them after every slide change. Instead of fighting that
 * timing, we just force the arrows to match the main image
 * Swiper's real isBeginning/isEnd state on every slide change and
 * on a short interval, so whichever slider touched the classes
 * last doesn't matter - the true image position always wins.
 */
(function () {
  function syncArrows() {
    var mediaEl = document.querySelector('.product-media');
    if (!mediaEl || !mediaEl.swiper) return;
    var swiper = mediaEl.swiper;
    var nextEl = document.querySelector('.swiper-button-next');
    var prevEl = document.querySelector('.swiper-button-prev');
    if (nextEl) {
      nextEl.classList.toggle('swiper-button-disabled', !!swiper.isEnd);
      nextEl.classList.toggle('invisible', !!swiper.isEnd);
    }
    if (prevEl) {
      prevEl.classList.toggle('swiper-button-disabled', !!swiper.isBeginning);
      prevEl.classList.toggle('invisible', !!swiper.isBeginning);
    }
  }

  function bindSync() {
    var mediaEl = document.querySelector('.product-media');
    if (!mediaEl || !mediaEl.swiper) {
      setTimeout(bindSync, 300);
      return;
    }
    var swiper = mediaEl.swiper;
    swiper.on('slideChange', syncArrows);
    swiper.on('transitionEnd', syncArrows);
    syncArrows();
  }

  document.addEventListener('DOMContentLoaded', bindSync);
  document.addEventListener('shopify:section:load', bindSync);

  // Belt-and-suspenders: keep correcting for as long as the page
  // lives, in case the thumbnail slider reasserts stale classes
  // asynchronously after our own sync runs.
  setInterval(syncArrows, 300);
})();

/**
 * Optional Shipping Protection ($2) - opt-in checkbox in the cart drawer.
 * Adds/removes the hidden "Shipping Protection" product (variant below).
 * - The protection line is hidden from the cart item list (the checkbox
 *   is the only control), so it can't be set to a quantity above 1.
 * - If the real items are removed, the protection line is removed too so
 *   nobody can check out with only the $2 fee.
 * - Unchecked by default; shopper opts in.
 */
(function () {
  var VID = 53154532589850;
  var busy = false;

  var style = document.createElement('style');
  style.textContent =
    '[data-cart-item]:has(a[href*="/products/shipping-protection"]){display:none !important}' +
    '.ship-protect{display:flex;align-items:flex-start;gap:12px;margin:0 0 12px;padding:12px 14px;background:#1A1A1A;border:2px solid #FF2E93;border-radius:10px;cursor:pointer;text-align:left}' +
    '.ship-protect input{margin-top:3px;width:20px;height:20px;flex:0 0 auto;accent-color:#FF2E93;cursor:pointer}' +
    '.ship-protect-title{display:block;font-weight:800;font-size:15px;color:#fff;line-height:1.3}' +
    '.ship-protect-title b{color:#F5FF00}' +
    '.ship-protect-desc{display:block;font-size:12px;color:rgba(255,255,255,.7);line-height:1.4;margin-top:2px}';
  document.head.appendChild(style);

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function fmt(c) { return '$' + (c / 100).toFixed(2); }

  function ensureRow() {
    var host = document.querySelector('[data-slider-cart-footer] .cart-checkout');
    if (!host) return null;
    var row = host.querySelector('[data-ship-protect]');
    if (!row) {
      row = document.createElement('label');
      row.className = 'ship-protect';
      row.setAttribute('data-ship-protect', '');
      row.innerHTML =
        '<input type="checkbox" data-ship-protect-input>' +
        '<span><span class="ship-protect-title">Add Shipping Protection <b>+$2.00</b></span>' +
        '<span class="ship-protect-desc">Optional coverage for packages lost, stolen, or damaged in transit. Claims are reviewed case by case.</span></span>';
      host.insertBefore(row, host.firstChild);
      row.querySelector('input').addEventListener('change', function (e) {
        var on = e.target.checked;
        busy = true;
        var req = on
          ? fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: VID, quantity: 1 }) })
          : fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(VID), quantity: 0 }) });
        req.then(function () { busy = false; sync(); }).catch(function () { busy = false; });
      });
    }
    return row;
  }

  function sync() {
    if (busy) return;
    getCart().then(function (cart) {
      var prot = null, others = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id === VID) prot = i; else others += i.quantity;
      });
      if (prot && !others) {
        busy = true;
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(VID), quantity: 0 }) })
          .then(function () { busy = false; });
      }
      if (prot && prot.quantity > 1) {
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(VID), quantity: 1 }) });
      }
      var row = ensureRow();
      if (!row) return;
      row.style.display = others ? 'flex' : 'none';
      row.querySelector('input').checked = !!prot;
      var prices = document.querySelectorAll('[data-slider-cart-total-container] .cart-price');
      if (prices.length) prices[prices.length - 1].textContent = fmt(cart.total_price);
    }).catch(function () { busy = false; });
  }

  setInterval(function () {
    var drawer = document.querySelector('[data-slider-cart]');
    if (drawer && drawer.offsetParent !== null) sync();
  }, 1200);
})();

/**
 * Sharper hover zoom: product cards load a small thumbnail (about 300-500px
 * wide) which looks blurry once the hover effect zooms it 2-3x. The first
 * time a shopper hovers a card, quietly fetch the 1728px version of the
 * same image and swap it in so the zoomed-in design stays crisp.
 */
(function () {
  var HI = 1728;
  var SEL = '.product-card-image img, .chaos-fp-card-img img, .chaos-na-img img';
  function upgrade(img) {
    if (!img || img.getAttribute('data-hires')) return;
    var cur = img.currentSrc || img.src || '';
    var m = cur.match(/_(\d+)x(\.[a-z]+)(\?.*)?$/i);
    if (!m || parseInt(m[1], 10) >= HI) return;
    var big = cur.replace(/_(\d+)x(\.[a-z]+)/i, '_' + HI + 'x$2');
    img.setAttribute('data-hires', '1');
    var pre = new Image();
    pre.onload = function () {
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
      img.src = big;
    };
    pre.src = big;
  }
  document.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var card = e.target.closest && e.target.closest('.product-card, .chaos-fp-card, .chaos-na-card');
    if (!card) return;
    var img = card.querySelector(SEL);
    upgrade(img);
  }, true);
})();

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */
